export class UniOrganizacional {
  id: number;
  sigla: string;
  nombre: string;
  estaActiva: boolean;
}
